<template>
  <a-modal
    :footer="null"
    :width="1280"
    :afterClose="handleAfterClose"
    v-model:visible="visible"
    :maskClosable="false"
    :title="$t('shopping_cart.upload_modal_result')"
  >
    <a-table
      :pagination="ipagination"
      :columns="columns"
      row-key="id"
      size="middle"
      :loading="loading"
      :data-source="dataSource"
      @change="handleTableChange"
    >
      <template #vehicleName="{text}">
        {{ text ? $t(text) : '' }}
      </template>
      <template #groupName="{text}">
        {{ text ? $t(text) : '' }}
      </template>
      <template #name="{text}">
        {{ $t(text) }}
      </template>
      <template #unit="{text}">
        {{ text ? $t(text) : '' }}
      </template>

      <template #unitPrice="{text}">
        {{ text !== null ? numeral(text || 0).format('$0,0.00') : '' }}
      </template>

      <template #totalPrice="{text}">
        {{ text !== null ? numeral(text || 0).format('$0,0.00') : '' }}
      </template>
    </a-table>

    <div class="pagination-container">
      <a-pagination
        v-model:current="ipagination.current"
        :page-size-options="ipagination.pageSizeOptions"
        :total="ipagination.total"
        show-size-changer
        v-model:pageSize="ipagination.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
        size="small"
        show-quick-jumper
      >
        <template #buildOptionText="props">
          <span>{{ props.value }} {{ $t('common.page_per_item_text') }}</span>
        </template>
      </a-pagination>
    </div>

    <div class="table-summary">
      <div>{{ $t('shopping_cart.total_price') }}</div>
      <div class="price">
        {{
          summaryTotal !== null
            ? numeral(summaryTotal || 0).format('$0,0.00')
            : ''
        }}
      </div>

      <a-button @click="handleSubmitOrder" class="submit-btn" type="primary">{{
        $t('shopping_cart.submit')
      }}</a-button>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import numeral from 'numeral';
import {
  getShoppingcartPage,
  submitImportOrder,
  getImportTotalPrice
} from '@/api/apis';

export default defineComponent({
  name: 'UploadModal',
  data() {
    return {
      numeral,
      visible: true,
      columns: [
       {
          title: this.$t('shopping_cart.vehicle_name'),
          dataIndex: 'vehicleName',
          width: 100,
          slots: { title: 'pvehicle_name-title', customRender: 'vehicleName' }
        },
        {
          title: this.$t('shopping_cart.sc_part_type'),
          dataIndex: 'groupName',
          width: 100,
          slots: { customRender: 'groupName' }
        },
        {
          title: this.$t('shopping_cart.sc_name'),
          dataIndex: 'name',
          width: 100,
          slots: { customRender: 'name' }
        },
        {
          title: this.$t('shopping_cart.sc_part_no'),
          dataIndex: 'modelNum',
          width: 120
        },
        {
          title: this.$t('shopping_cart.sc_part_code'),
          dataIndex: 'partCode',
          width: 100
        },
        {
          title: this.$t('shopping_cart.sc_unit'),
          dataIndex: 'unit',
          width: 100,
          slots: { customRender: 'unit' }
        },
        {
          title: this.$t('shopping_cart.sc_quantity'),
          dataIndex: 'quantity',
          width: 100
        },
        // {
        //   title: this.$t('shopping_cart.sc_unit_price'),
        //   dataIndex: 'unitPrice',
        //   width: 100,
        //   slots: { customRender: 'unitPrice' }
        // },
        // {
        //   title: this.$t('shopping_cart.sc_total_price'),
        //   dataIndex: 'totalPrice',
        //   width: 100,
        //   slots: { customRender: 'totalPrice' }
        // },
        {
          title: this.$t('shopping_cart.sc_consignee'),
          dataIndex: 'consignee',
          width: 100
        },
        {
          title: this.$t('shopping_cart.sc_remark'),
          dataIndex: 'remark',
          width: 120
        }
      ],
      summaryTotal: null,
      loading: false,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSizeOptions: ['5', '10', '15'],
        total: 0,
        showSizeChanger: true,
        pageSize: 5,
        showQuickJumper: true
        // size: 'large'
      }
    };
  },
  created() {
    this.loadData();

    this.getTotalPrice();
  },
  emits: ['after-close'],
  methods: {
    async getTotalPrice() {
      const res = await getImportTotalPrice();

      if (res.success) {
        this.summaryTotal = res.result;
      }
    },
    async loadData() {
      this.loading = true;
      const res = await getShoppingcartPage({
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        shoppingType: '3' // 从文件上传的数据
      });

      if (res.success) {
        this.dataSource = res.result.records || [];

        this.ipagination.total = res.result.total || 0;
      }

      this.loading = false;
    },
    handleAfterClose() {
      this.$emit('after-close');
    },
    handleTableChange(pagination) {
      this.ipagination = pagination;

      this.loadData();
    },
    onShowSizeChange(current) {
      this.ipagination.current = current;

      this.loadData();
    },
    onChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;

      this.loadData();
    },
    async handleSubmitOrder() {
      this.loading = true;
      const res = await submitImportOrder();

      if (res.success) {
        this.visible = false;
      }

      this.loading = false;
    }
  }
});
</script>

<style lang="scss" scoped>
.table-summary {
  background: #e5eaf4;
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  .price {
    font-size: $secondary-fontsize;
    color: $primary-color;
    font-weight: bold;
    margin: 0 40px 0 20px;
  }

  .submit-btn {
    padding: 0 50px;
    height: 100%;
  }
}

.pagination-container {
  margin: 20px 0;
  text-align: right;
}

// 隐藏table自带的pagination
::v-deep(.ant-table-pagination) {
  display: none;
}
</style>
